// src/services/CurrencyService.ts

import { BaseService } from "@services/BaseService";

class CurrencyService extends BaseService {
  getCurrencies() {
    return this.get(`/currencies/`);
  }
}

export const currencyService = new CurrencyService();
